import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { StgFollowUpRequest } from '../../types/account'
import api from '../../api'

const useSubmitStgFollowUp = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (payload: StgFollowUpRequest) => api.accounts.submitStgFollowUp(payload),
		onSuccess: (_data, variables) => {
			const id = variables.accountRequestID
			queryClient.invalidateQueries({ queryKey: ['accounts', id] })
			queryClient.invalidateQueries({ queryKey: ['accounts'] })
		}
	})
}

export default useSubmitStgFollowUp
